<template>
  <div class="login-form d-flex flex-column border p-4 p-md-5">
    <form v-on:submit.prevent="submitLogin">
      <div class="register-field">
        <BasicLabel
          :title="$t('forms.emailAdress')"
          :required="true"
          class="fw-bold"
        />
        <BasicInputText
          :hasRoundedCorners="true"
          class="login-input"
          :placeholder="$t('forms.username')"
          v-model="email"
        />
        <div v-if="v$.email.$errors.length" class="text-danger">
          <div class="input-errors" v-for="error of v$.email.$errors" :key="error.$uid">
            <div class="error-msg">{{ error.$message }}</div>
          </div>
        </div>
      </div> 
      <div class="register-field-last mb-0">
        <BasicLabel :title="$t('forms.password')" class="fw-bold" :required="true" />
        <BasicInputText
          :hasRoundedCorners="true"
          class="login-input"
          type="password"
          :placeholder="$t('forms.password')"
          v-model="password"
        />
      </div>
      <div v-if="v$.password.$errors.length" class="text-danger">
        <div class="input-errors" v-for="error of v$.password.$errors" :key="error.$uid">
          <div class="error-msg">{{ error.$message }}</div>
        </div>
      </div>
      <div v-else-if="loginAttempt == false" class="text-danger">
          <div class="error-msg">{{ $t('forms.emailOrPasswordWrong') }}</div>
      </div>

      <div class="d-flex flex-row align-items-start my-3">
        <basic-label :title="$t('forms.rememberMe')" class="fw-bold" :forInput="'rememberMe'">
          <template v-slot:before>
            <input
              class="form-check-input me-2"
              type="checkbox"
              value=""
              id="rememberMe"
              name="rememberMe"
              v-model="rememberMe"
            />
          </template>
        </basic-label>
      </div>

      <ButtonFilled
        class=" Minicart_button fw-bold text-white"
        :text="$t('common.logIn')"
        :hasRoundedCorners="true"
      />
    </form>
    <!-- <link-wrapper
      :location="'/blog'"
      class="text-decoration-none text-dark fs-6 mt-3 fw-bold"
    >
      <span>Lost Your Password ?</span>
    </link-wrapper> -->
  </div>
</template>

<script>
import ButtonFilled from "../../atoms/Button/ButtonFilled.vue";
// import LinkWrapper from "../../atoms/LinkWrapper/LinkWrapper.vue";
import BasicLabel from "../../atoms/FormInput/BasicLabel.vue";
import BasicInputText from "../../atoms/FormInput/BasicInputText.vue";
import { userLoginService } from '../../../services/authService';
import { useVuelidate } from '@vuelidate/core';
import { required, email } from '@vuelidate/validators';
import LoaderMixin from '../../../components/molecules/Mixin/loader';
import { LOGGED_IN_USER } from '../../../constents/app';

export default {
  components: {
    ButtonFilled,
    // LinkWrapper,
    BasicLabel,
    BasicInputText,
  },
  mixins: [LoaderMixin],
  setup () {
    return { v$: useVuelidate() }
  },
  validations () {
    return {
      email: { required, email },
      password: { required }
    }
  },
  data() {
    return {
      email: '',
      password: '',
      rememberMe: '',
      loginAttempt: undefined,
    };
  },
  methods: {
    async submitLogin() {
      this.v$.$touch();
      if (this.v$.$invalid) return;
      let loader = this.loader();
      let res = await userLoginService({
        "email": this.email,
        "password": this.password,
        "type": "username_password"
      });

      this.loginAttempt = true;
      if (!res || !res.token || res.code === "INVALID_USERNAME_OR_PASSWORD") {
        this.loginAttempt = false;
      } else {
        localStorage.setItem('userToken', res.token);
        if (res.refreshtoken) {
          localStorage.setItem('refreshtoken', res.refreshtoken);
        }
        // Drop guest-owned cart/wishlist on identity change — the backend
        // rejects cross-owner writes with OPERATION_DENIED. Without a
        // server-side cart-merge endpoint, clearing is the safe default.
        localStorage.removeItem('carrelloId');
        this.$store.commit('resetCart');
        this.$store.commit('wishlist/resetWishlist');
        this.$store.dispatch("user/updateLoggedInUserType", LOGGED_IN_USER);
        this.$router.push(this.$route.query.redirect || { name: "ShopDefault" });
      }

      loader.hide();
    }
  }
};
</script>
<style scoped="scoped">
.login-input {
  height: 40px !important;
  padding: 10px 20px !important;
  box-shadow: none !important;
  margin-top: 10px;
}
.Minicart_button {
  height: 40px !important;
  width: 150px !important;
}
.register-field-last {
  margin-top: 30px !important;
}
.register-field-last {
  margin-bottom: 35px;
}

@media screen and (max-width: 768px) {
  .login-input {
    width: 100% !important;
  }
  .my-account-register {
    padding: 0px !important;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .login-input {
    width: 250px !important;
  }
  .form-check-input {
    width: 15px !important;
  }
}
</style>
